import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=2f0b5c8a&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=ts&"
export * from "./NavBar.vue?vue&type=script&lang=ts&"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=2f0b5c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b5c8a",
  null
  
)

export default component.exports